import { useSnackbar } from 'notistack';
import useSWR from 'swr';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { SlaBreachRules } from '../types';

export const useSlaBreachRules = () => {
  const { enqueueSnackbar } = useSnackbar();
  const token = useAuthToken();

  const { data, error } = useSWR<SlaBreachRules[], ApiError>(
    token
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.SlaBreach().slaBreachRules.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status !== HTTP_STATUS_CODE.NOT_FOUND &&
          e.status !== HTTP_STATUS_CODE.UNAUTHORIZED
        ) {
          return enqueueSnackbar(e.title, { variant: 'error' });
        }
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    slaBreachRules: data,
    error,
    isLoading: !data && !error,
  };
};
